import { render, staticRenderFns } from "./ErrorRead.vue?vue&type=template&id=4ef01ad6&scoped=true&"
import script from "./ErrorRead.vue?vue&type=script&lang=ts&"
export * from "./ErrorRead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef01ad6",
  null
  
)

export default component.exports